
import React, { createContext, useContext, useState, useEffect } from 'react';
import {Helper} from '../tools/Helper';
import {api_Routes} from "../api_Routes";
import {useAuth} from "../AuthContext/AuthContext";

const BalanceContext = createContext();

export const useBalance = () => {
    return useContext(BalanceContext);
};

export const BalanceProvider = ({ children }) => {
    const [balance, setBalance] = useState(null);
    const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(true);
    const {auth} = useAuth()
    console.log(balance)

    useEffect(() => {
        if (auth){
            fetchBalance();
            fetchTransactions();
        }

    }, [auth]);

    const fetchBalance = async () => {
        try {
            const {response} = await Helper.Get({
                url:api_Routes.Balance.GetBalance,
                hasToken: true,
            });
            if (response){
                setBalance(parseFloat(response.data));
            }

        } catch (error) {
            console.error('Error fetching balance:', error);
        }
    };

    const fetchTransactions = async () => {
        try {
            const response = await Helper.Get({
                url:api_Routes.Balance.GetBalanceHistory,
                hasToken: true,
            });
            setTransactions(response.data);
        } catch (error) {
            console.error('Error fetching transactions:', error);
        } finally {
            setLoading(false);
        }
    };

    const deposit = async (amount, paymentMethod) => {
        try {
            const response = await Helper.post({
                url:api_Routes.Balance.GetBalance,
                data:{
                    amount,
                    payment_method: paymentMethod
                },
                hasToken: true,
            } );

            setBalance(response.data.new_balance);
            await fetchTransactions();

            return { success: true, data: response.data };
        } catch (error) {
            return {
                success: false,
                error: error.response?.data?.message || 'Deposit failed'
            };
        }
    };

    // const purchaseWithBalance = async (amount, serviceId, description) => {
    //     try {
    //         const response = await api.post('/balance/purchase', {
    //             amount,
    //             service_id: serviceId,
    //             description
    //         });
    //
    //         setBalance(response.data.new_balance);
    //         await fetchTransactions();
    //
    //         return { success: true, data: response.data };
    //     } catch (error) {
    //         return {
    //             success: false,
    //             error: error.response?.data?.message || 'Purchase failed'
    //         };
    //     }
    // };

    const value = {
        balance,
        transactions,
        loading,
        deposit,
        // purchaseWithBalance,
        refreshBalance: fetchBalance,
        refreshTransactions: fetchTransactions
    };

    return (
        <BalanceContext.Provider value={value}>
            {children}
        </BalanceContext.Provider>
    );
};